<h1 mat-dialog-title>{{"why-early-late.title" | translate}}</h1>
<div mat-dialog-content>
  <h3>{{"why-early-late.warning" | translate}}</h3>
  <mat-form-field>
    <mat-label>{{"why-early-late.reason" | translate}}</mat-label>
    <input matInput [(ngModel)]="reason">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">{{"buttons.cancel" | translate}}</button>
  <button mat-button (click)="onConfirm()">{{"buttons.accept" | translate}}</button>
</div>
